
























































import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import FlightOrder from "@/service/flightService";
import { DurationTime } from "@/utils/utils.ts";
import { Checkbox, CheckboxGroup, Overlay,Dialog } from "vant";
@Component({
  name: "flightCahngePdt",
  components: {
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [Overlay.name]: Overlay,
  },
  filters: {
    DurationTime,
  },
})
export default class FlightCahngePdt extends Vue {
  //data
  productData = [];
  result: any = [];
  consumerResult: any[] = [];
  isShowRules = false;
  //computed
  get UniqueID(): string {
    return (this as any).$route.query.UniqueID;
  }
  get ServiceCode(): string {
    return (this as any).$route.query.ServiceCode;
  }
  get RuleType(): string {
    return (this as any).$route.query.RuleType;
  }

  //mounted
  mounted() {
    this.getOrderDetails();
  }
  //methods
  getTripNum(number: number) {
    return number == 0 ? this.$root.$t("order_flight_flightdetail_yi") : this.$root.$t("order_flight_flightdetail_er");
  }
  getOrderDetails() {
    FlightOrder.OrderDetails(this.UniqueID).then(res => {
      if (res.isSucc) {
        this.productData = res.result;
        if(res.result.ClientUniqueID && this.RuleType !== 'Refund'){
          Dialog.confirm({
            title: '温馨提示',
            message: '审批单改签仅限改签当天航班！',
            confirmButtonText: '我已知晓',
            showCancelButton: false,
            width:'70%'
          })
          .then(() => {
            // on confirm
          })
          .catch(() => {
            // on cancel
          });
        }
        this.$emit("setProductData", res.result);
      }
    });
  }
  changeProducts(value: any) {
    this.$emit("setResult", value);
  }
  changeConsumers(value: any) {
    this.$emit("setConsumerResult", value);
  }
  formatDate(value: Date, format: string = "HH:mm") {
    if (!value) {
      return value;
    }
    return (this as any).$moment(value).format(format);
  }
  overlayValue = [];
  showRule(rules: any) {
    if (rules == "" || (this.productData as any)?.ApplyArea == 1127) {
      return this.$toast(this.$root.$t("mall_modules_refund_tuigaiqianguizejifeiyongbiaozhunshijixuyihangsiweizhun"));
    }
    this.overlayValue = rules.split("；");
    this.isShowRules = true;
  }
}
